import { isAiXstateMigrationEnabled } from '@atlaskit/editor-common/ai-xstate-migration';
import { isExperimentEnabled } from '@atlaskit/platform-feature-experiments/is-experiment-enabled';

/** Capture once per action; rollback must not change an in-flight scheduler. */
export function isStrictFifoToolCallsEnabled(): boolean {
	return (
		isAiXstateMigrationEnabled() && isExperimentEnabled('platform_editor_ai_strict_fifo_tool_calls')
	);
}
